const pageNameKey = "indicatorText";

export const indicatorTextEn = {
  [pageNameKey]: {
    indicatorTextIconAltText: "Icon button",
  },
};

export const indicatorTextPtBr = {
  [pageNameKey]: {
    indicatorTextIconAltText: "Botão de ícone",
  },
};

export const indicatorTextDe = {
  [pageNameKey]: {
    indicatorTextIconAltText: "Symbolbutton",
  },
};

export const indicatorTextZhHans = {
  [pageNameKey]: {
    indicatorTextIconAltText: "图标按钮",
  },
};

export const indicatorTextIt = {
  [pageNameKey]: {
    indicatorTextIconAltText: "Pulsante icona",
  },
};

export const indicatorTextEs = {
  [pageNameKey]: {
    indicatorTextIconAltText: "Botón de icono",
  },
};

export const indicatorTextNl = {
  [pageNameKey]: {
    indicatorTextIconAltText: "Pictogramknop",
  },
};

export const indicatorTextTr = {
  [pageNameKey]: {
    indicatorTextIconAltText: "Simge düğmesi",
  },
};
